module.exports = __webpack_public_path__ + "static/media/cyberark-light.caa5bfe5.png";